(function ($) {
    $(document).ready(function () {
        galleryCarousel();
    });

    function fixFancyboxSlick(innerElem) {
        return;
        // Fix for mini gallery fancy box
        var selector = '.slick-slide:not(.slick-cloned)';
        if (innerElem) {
            selector = selector + ' ' + innerElem;
        }
        // Skip cloned elements
        $().fancybox({
            selector: selector,
            backFocus: false,
            loop: true

        });
        // Remove fancybox cloned elements
        if (innerElem) {
            $('.slick-cloned ' + innerElem).each(function () {
                $(this).removeAttr('data-fancybox');
            });

        } else {
            $('.slick-cloned .thumb').removeAttr('data-fancybox');
        }


        // Attach custom click event on cloned elements,
        // trigger click event on corresponding link
        var clonedElement = '.slick-cloned';
        if (innerElem) {
            clonedElement = '.slick-cloned ' + innerElem;
        }
        $(document).on('click', clonedElement, function (e) {
            $(selector)
                .eq(($(e.currentTarget).attr("data-slick-index") || 0) % $(selector).length)
                .trigger("click.fb-start", {
                    $trigger: $(this)
                });

            return false;
        });
    }

    function galleryCarousel() {
        var wrapper = $('.gallery_section.carousel');
        wrapper.each(function () {
            var current = $(this);
            var wrap = current.find('.slider_inner_wrap');
            if (wrap.length > 0) {
                wrap.on("init", function () {
                    lazyLoadInstance.update();
                });
                wrap.slick({
                    rows: 0,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: false,
                    touchMove: false,
                    arrows: true,
                    dots: true,
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    appendDots: current.find('.pager'),
                    centerMode: true,
                    centerPadding: '380px',
                    variableWidth: false,
                    rtl: $('html').attr('dir') === 'rtl',
                    responsive: [
                        {
                            breakpoint: 1799,
                            settings: {
                                centerPadding: '190px'
                            }
                        },
                        {
                            breakpoint: 1199,
                            settings: {
                                centerPadding: '120px'
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                arrows: true,
                                dots: false,
                                centerPadding: 0,
                            }
                        },
                    ]
                });

                fixFancyboxSlick('.thumb_content .description');
                wrap.trigger('builder_gallery_ready');

                var select = current.find('.filters_select select');
                var filters = {};

                select.change(function () {
                    var $this = $(this);
                    var group = $this.attr('data-filter-group');

                    $this.trigger('builder_gallery_select_click');

                    filters[group] = $this.find(':selected').attr('data-filter-value');
                    var isoFilters = [];
                    for (var prop in filters) {
                        isoFilters.push(filters[prop])
                    }
                    var selector = isoFilters.join(''),
                        newRel = selector.replace('.', '');
                    wrap.find('.thumb_wrap' + selector).find('.thumb').attr("data-fancybox", newRel + '_thumb');
                    wrap.slick('slickUnfilter');

                    if (selector !== '') {
                        wrap.slick('slickFilter', selector);
                    }
                    fixFancyboxSlick('.thumb_content .description');
                    return false;
                });

            }
        });
    }


}(jQuery));